import styled from "styled-components"

export const ButtonList = styled.div`
  display: flex;
  flex-flow: wrap;

  margin-bottom: -8px;

  & > * {
    margin-right: 12px;
    margin-bottom: 8px;
  }
`
